import { Typography, Box, UserFlag } from 'src/components';
import { getCategorySymbol } from 'src/data';
import placeholderImage from 'src/assets/placeholders/140x140.png';

export default function FeatureListCard({ feature, coords, onClick, allCountries }) {
    if (!feature) return null;

    const hasImage = feature.images !== null && feature.images !== undefined && feature.images !== "[]" && feature.images?.length !== 0;
    const countryIsoAlpha2 = allCountries.find(x => x.name === feature.country)?.code;
    const categoryIconPath = getCategorySymbol(feature.category);
    const isHiddenGem = feature.category === "Hidden Gems";

    return (
        <Box
            sx={{
                border: '2px solid',
                borderColor: isHiddenGem ? '#FFEB99' : '#E0E0E0', 
                borderRadius: 2,
                width: '100%',
                mb: 1,
                p: 0.5,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: isHiddenGem
                    ? '0 0 6px rgba(255, 215, 0, 0.4)' // soft glow
                    : 0,
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    boxShadow: isHiddenGem
                        ? '0 0 10px rgba(255, 215, 0, 0.6)'
                        : '0 0 6px rgba(0,0,0,0.1)',
                    },
            }}
            onClick={() => onClick(feature, coords)}
            >
            {/* Image */}
            <Box
                component="img"
                src={hasImage ? feature.images : placeholderImage}
                alt={feature.title || 'Feature image'}
                sx={{
                width: 45,
                height: 50,
                borderRadius: 1,
                marginRight: 2,
                objectFit: 'cover',
                }}
            />

            {/* Middle content (title + description) */}
            <Box sx={{ flex: 1, mr: 2 }}>
                <Typography variant="h6">{feature.title}</Typography>
                <Typography variant="body2">{feature.description}</Typography>
            </Box>

            {/* Right side: Flag + Category Icon */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {countryIsoAlpha2 && <UserFlag size={16} countryCode={countryIsoAlpha2} />}

                <Box
                    component="img"
                    src={categoryIconPath}
                    alt={feature.category}
                    sx={{ width: 20, height: 20, mt: 0.5 }}
                    />
            </Box>
        </Box>
    );
}
